import { ENDPOINTS } from '@iziping/common';

export interface AppConfig {
    googleClientId?: string;
}

let _config: AppConfig = {};

export const getConfig = (): AppConfig => _config;

export const loadConfig = async (): Promise<void> => {
    try {
        const response = await fetch(ENDPOINTS.config, { cache: 'no-store' });
        if (response.ok) {
            _config = (await response.json()) as AppConfig;
        }
    } catch {
        // config non critique, on continue sans
    }
};
